import styled from "styled-components";

export const TFoot = styled.tfoot`
  position: sticky;
  inset:  auto 0 -12px;
  background-color: ${props => props.theme.backgrounds.white};
  color: ${props => props.theme.colors.black};
  font-weight: bold;

`

export const TableWrapper = styled.div`
    position: relative;
    width: 100%;
    height: 100%;

    thead, tr, th{
      cursor:pointer
    }

  thead{
    font-weight: ${props => props.theme.font_weight.large};
    line-height: 130%;
    border-bottom: ${props => props.theme.border.very_small_gray5};
    position: sticky;
    top:${props => props.padding !== undefined ? `-${props.padding}` : `-${props.theme.paddings.large}`} ;
    background-color: ${props => props.theme.backgrounds.white};
    color: ${props => props.theme.colors.black};
  }

  tbody{
    cursor: pointer;
    color: ${props => props.theme.colors.black};
  }

  tbody tr:hover{
    background: ${props => props.theme.backgrounds.gray7} ;
  }

  tr, td{
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    -webkit-box-orient: horizontal; 
    max-width:350px ;
  }


`;